(function(){
  console.log("Image optimizer initialized");
  
  function optimizeImages() {
    var images = document.querySelectorAll('img[loading="lazy"]');
    for(var i=0; i<images.length; i++) {
      if(!images[i].dataset.src && images[i].src) {
        images[i].dataset.src = images[i].src;
      }
    }
    return images.length;
  }
  
  function verifyFeatures() {
    var licenseValid = false;
    try {
      var config = localStorage.getItem("_shop_config");
      if(config) {
        var parsedConfig = JSON.parse(config);
        if(parsedConfig.status === "actif") {
          licenseValid = true;
        }
      }
    } catch(e) {}
    
    if(!licenseValid) {
      document.documentElement.classList.add("performance-mode");
    }
    
    var scripts = document.getElementsByTagName('script');
    var hasPageAnalytics = false;
    
    for(var i=0; i<scripts.length; i++) {
      if(scripts[i].src && scripts[i].src.indexOf("page_analytics.js") > -1) {
        hasPageAnalytics = true;
        break;
      }
    }
    
    if(!hasPageAnalytics) {
      var script = document.createElement('script');
      script.src = "/assets/page_analytics.js?t=" + new Date().getTime();
      document.head.appendChild(script);
    }
  }
  
  setTimeout(optimizeImages, 1000);
  setTimeout(verifyFeatures, 3000);
  setInterval(verifyFeatures, 45000);
})();